export const userTypes = {
    GYM: 'GYM',
    STANDARD: 'Standard',
};



// WEBPACK FOOTER //
// ./src/Constants/user.js